export const SET_AFFILIATE = '[affiliate] set affiliate';

export interface SetAffiliate {
  type: typeof SET_AFFILIATE;
  payload: { affiliate: string };
}
